/*
  COMPONENT: ArtistCard
  PURPOSE: Displays an artist image with summary details for use in Carousels
*/
import React from 'react'
import { Link } from 'gatsby'
import styled, { css } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

// components
import ResponsiveImage from './ResponsiveImage'

// styles
const Card = styled(Link)`
  max-width: calc(
    100vw - ${(props) => props.theme.mobileGutter} -
      ${(props) => props.theme.mobileCardSpacing} -
      ${(props) => props.theme.cardPeeking}
  );
  width: 343px;
  text-decoration: none;

  ${breakpoint('desktop')`
    display: flex;
    width: 717px;
    max-width: unset;
    padding: 0;
  `}

  & + & {
    margin-left: ${(props) => props.theme.mobileCardSpacing};

    ${breakpoint('desktop')`${css`
      margin-left: ${(props) => props.theme.desktopCardSpacing};
    `}`}
  }
`
const ArtistImage = styled.div`
  max-width: calc(
    100vw - ${(props) => props.theme.mobileGutter} -
      ${(props) => props.theme.mobileCardSpacing} -
      ${(props) => props.theme.cardPeeking}
  );
  width: 343px;

  ${breakpoint('desktop')`
    margin-right: 43px;
    width: 393px;
    max-width: unset;
    padding: 0;
  `}
`
const ArtistInfo = styled.div`
  width: 90%;

  h2 {
    margin: 8px 0 0;
    font-size: 23px;
    font-weight: normal;
    letter-spacing: 0.1px;
    color: ${(props) => props.theme.headingDark};
  }

  h3 {
    margin-bottom: 12px;
    font-size: 15px;
    font-weight: normal;
    line-height: 1.87;
    letter-spacing: 0.3px;
    color: ${(props) => props.theme.headingDark};
  }

  p {
    margin: 0;
    height: 110px;
    overflow: hidden;
    ${(props) => props.theme.typography.baseText.mobile}
    color: ${(props) => props.theme.textDark};
  }

  ${breakpoint('desktop')`${css`
    width: 281px;

    h2 {
      margin: 50px 0 4px;
      font-size: 29px;
      font-weight: normal;
      line-height: normal;
      letter-spacing: 0.2px;
    }

    h3 {
      margin-bottom: 32px;
      font-size: 18px;
      font-weight: normal;
      line-height: 1.56;
      letter-spacing: 0.3px;
    }

    p {
      margin: 0;
      height: auto;
      overflow-y: visible;
      ${(props) => props.theme.typography.baseText.desktop}
    }
  `}`}
`

// view
const ArtistCard = ({ artist }) => {
  const artistImage = artist.metadata.artist_image.imgix_url
  const artistName = artist.title
  const artistTitle = artist.metadata.artist_title
  const artistSummary = artist.metadata.artist_summary
  const linkToArtistDetail = `/artists/${artist.slug}`

  return (
    <Card to={linkToArtistDetail}>
      <ArtistImage>
        <ResponsiveImage
          image={artistImage}
          w={400}
          h={400}
          crop="top"
          title={artistName}
          alt={`Artist - ${artist.title}`}
          noStyleDimensions
        />
      </ArtistImage>

      <ArtistInfo>
        <h2>{artistName}</h2>

        <h3>{artistTitle}</h3>

        <p>{artistSummary}</p>
      </ArtistInfo>
    </Card>
  )
}

export default ArtistCard
